const SpecialToolsPage = props => (
  <div className="content">
    <div className="m-b-lg">
      <h4 className="is-size-4 m-b-md">{props.t('common:special-tools')}</h4>
      <div className="m-b-md">
        {props.t('common:special-tools-content-1')} <a href="https://www.mazdatoolandequipment.com" target="_blank">www.mazdatoolandequipment.com</a>. <br />
        {props.t('common:special-tools-content-2')}
      </div>
    </div>
  </div>
)

export default SpecialToolsPage



// WEBPACK FOOTER //
// ./components/SpecialTools/index.js